import { Shield, Clock, Award, MapPin, Users } from "lucide-react";
import { smoothScrollTo } from "../utils/smoothScroll";

const differentiators = [
  {
    icon: Shield,
    title: "Trusted & Certified",
    description: "Certified technicians with decades of combined experience serving New England's finest establishments.",
  },
  {
    icon: Clock,
    title: "Reliable Scheduling",
    description: "Flexible scheduling that works around your business. We show up on time, every time.",
  },
  {
    icon: MapPin,
    title: "Local Expertise",
    description: "Deep knowledge of New Hampshire and New England craft beer trends, regulations, and best practices.",
  },
  {
    icon: Users,
    title: "Education First",
    description: "We don't just clean—we educate. Learn how to maximize pour quality and reduce waste.",
    link: "#resources",
  },
  {
    icon: Award,
    title: "Quality Guarantee",
    description: "100% satisfaction guaranteed. If you're not happy with our service, we'll make it right.",
  },
];

export default function WhyTibsTaps() {
  return (
    <section id="why-us" className="py-24 bg-[#0A0A0A]" data-testid="why-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Stainless Steel Divider */}
        <div className="stainless-line w-full mb-16" />

        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div
          >
            <p className="overline mb-4" data-testid="why-overline">Why Choose Tibs Taps</p>
            <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl text-white mb-6" data-testid="why-heading">
              Your Draft System{" "}
              <span className="gold-text">Deserves the Best</span>
            </h2>
            <p className="text-[#A1A1AA] text-lg mb-8">
              For over 15 years, Tibs Taps has been the trusted name in draft beer service 
              across New England. We combine old-school reliability with 
              modern techniques to keep your taps flowing perfectly.
            </p>

            {/* Trust Badges */}
            <div className="flex flex-wrap gap-4">
              <div className="px-4 py-2 bg-[#141414] border border-[#27272A] rounded-lg">
                <span className="text-[#D4AF37] font-heading text-2xl">15+</span>
                <span className="text-[#A1A1AA] text-sm ml-2">Years</span>
              </div>
              <div className="px-4 py-2 bg-[#141414] border border-[#27272A] rounded-lg">
                <span className="text-[#D4AF37] font-heading text-2xl">150+</span>
                <span className="text-[#A1A1AA] text-sm ml-2">Clients</span>
              </div>
              <div className="px-4 py-2 bg-[#141414] border border-[#27272A] rounded-lg">
                <span className="text-[#D4AF37] font-heading text-2xl">NH</span>
                <span className="text-[#A1A1AA] text-sm ml-2">Based</span>
              </div>
            </div>
          </div>

          {/* Right Grid */}
          <div
            className="grid grid-cols-1 sm:grid-cols-2 gap-4"
          >
            {differentiators.map((item, index) => (
              <div
                key={item.title}
                className={`p-6 bg-[#141414] border border-[#27272A] rounded-xl card-hover ${item.link ? 'cursor-pointer' : ''}`}
                data-testid={`why-card-${index}`}
                onClick={item.link ? () => smoothScrollTo(item.link) : undefined}
              >
                <div className="w-10 h-10 rounded-lg bg-[#D4AF37]/10 flex items-center justify-center mb-4">
                  <item.icon className="w-5 h-5 text-[#D4AF37]" />
                </div>
                <h3 className="font-heading text-white mb-2">{item.title}</h3>
                <p className="text-[#A1A1AA] text-sm">{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
